export default {"src":"/_next/static/media/inputClearSvg.0e626c65.svg","height":16,"width":16};